export default __webpack_public_path__ + "static/media/abstracto1768.a99fa64e.jpg";